import React from "react";

import type { CircleIconProps } from "./types";

const CircleIcon = ({ fill }: CircleIconProps) => (
  <circle
    r={6}
    cx={6}
    cy={6}
    fill={fill}
  />
);

export default CircleIcon;
